"use client";

import { useEffect } from "react";

import type { Sku, UseSliderSkusProps } from "../productItem.types";

export function useSliderSkus({
  skus,
  selectedSku,
  setFirstClick,
  setSelectedSku,
  setShowAddToCart
}: UseSliderSkusProps) {
  const sortedSkus =
    skus &&
    skus.slice().sort((skuA, skuB) => {
      const priceA = skuA.seller.price ?? 0;
      const priceB = skuB.seller.price ?? 0;
      return priceA - priceB;
    });

  const handleChangeSku = (item: Sku) => {
    setSelectedSku(item);
    setShowAddToCart(true);
    setFirstClick(false);
  };

  const handleClickSku = (item: Sku) => {
    item.name === selectedSku.name ? () => true : handleChangeSku(item);
  };

  useEffect(() => {
    const skuSelected = document.querySelector(`.chip__${selectedSku.id}`);
    const carousselParent = skuSelected?.closest(".carousel__container");

    if (carousselParent && skuSelected) {
      const difference =
        skuSelected?.getBoundingClientRect()?.left -
        carousselParent?.getBoundingClientRect()?.left;

      if (difference) {
        carousselParent.scrollBy({
          top: 0,
          left: difference - skuSelected?.getBoundingClientRect()?.width
        });
      }
    }
  }, [selectedSku.id]);

  return {
    sortedSkus,
    handleClickSku
  };
}
